import React, { Fragment } from 'react'

import { take } from 'lodash'
import PropTypes from 'prop-types'

import { MonthView as CalendarEvent } from '../CalendarEvent'
import './index.scss'

const MAX_EVENTS_DISPLAYED_PER_DAY = 5

class MonthDayEvents extends React.Component {
  renderEvents(events) {
    return events.map((evt) => {
      return (
        <div
          className="month-event"
          key={evt.Id}
        >
          <CalendarEvent
            event={evt}
            renderDate={this.props.renderDate}
            onEventChange={this.props.onEventChange}
          />
        </div>
      )
    })
  }
  renderWithMore(events) {
    const displayedEventsCount = MAX_EVENTS_DISPLAYED_PER_DAY - 1
    return (
      <Fragment>
        {this.renderEvents(take(events, displayedEventsCount))}
        <div className="more-events">+{events.length - displayedEventsCount} more</div>
      </Fragment>
    )
  }
  render() {
    const { events } = this.props
    return (
      <div className="month-day-events-comp">
        {events.length > MAX_EVENTS_DISPLAYED_PER_DAY ? this.renderWithMore(events) : this.renderEvents(events)}
      </div>
    )
  }
}

MonthDayEvents.propTypes = {
  renderDate: PropTypes.object.isRequired,
  events: PropTypes.array.isRequired,
  onEventChange: PropTypes.func.isRequired,
}

export default MonthDayEvents
